var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_678_3664)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.834 4.66667H4.66732C4.04848 4.66667 3.45499 4.9125 3.0174 5.35008C2.57982 5.78767 2.33398 6.38116 2.33398 7V23.3333C2.33398 23.9522 2.57982 24.5457 3.0174 24.9832C3.45499 25.4208 4.04848 25.6667 4.66732 25.6667H21.0007C21.6195 25.6667 22.213 25.4208 22.6506 24.9832C23.0882 24.5457 23.334 23.9522 23.334 23.3333V15.1667M21.584 2.91667C22.0481 2.45254 22.6776 2.19179 23.334 2.19179C23.9904 2.19179 24.6199 2.45254 25.084 2.91667C25.5481 3.38079 25.8089 4.01029 25.8089 4.66667C25.8089 5.32304 25.5481 5.95254 25.084 6.41667L14.0007 17.5L9.33398 18.6667L10.5007 14L21.584 2.91667Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_678_3664"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.b66f30c066a9ef75ee7a9c5983e99057.svg";
export { ForwardRef as ReactComponent };